import ServiceBase from './ServiceBase';

export default class PromotedProjectsService extends ServiceBase {
    constructor($http) {
        super($http);
    }

    getProjects(category  = null) {
        return this.request('get', 'promotedProjects/getProjects', { params: { category } });
    }
}
